import DashboardContent from 'components/lab/atoms/DashboardContent'
import { DenialsWorklist } from 'components/lab/billingDenial/DenialsWorklist'
import React from 'react'

export const DenialsWorklistPage = () => (
  <div>
    <DashboardContent
      title={'Denials'}
      icon="fas fa-ban"
      content={
        <div className="card card-primary mt-1 p-2">
          <DenialsWorklist />
        </div>
      }
    />
  </div>
)
